import { render, staticRenderFns } from "./SkuItem.vue?vue&type=template&id=6934c95b&scoped=true&"
import script from "./SkuItem.vue?vue&type=script&lang=js&"
export * from "./SkuItem.vue?vue&type=script&lang=js&"
import style0 from "./SkuItem.vue?vue&type=style&index=0&id=6934c95b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934c95b",
  null
  
)

export default component.exports